import * as React from 'react';
import { Link } from "react-router-dom";
import EditTwoToneIcon from '@mui/icons-material/EditTwoTone';
import DeleteOutlineTwoToneIcon from '@mui/icons-material/DeleteOutlineTwoTone';
import { Box, IconButton, Modal, Typography, Button } from '@mui/material';

const Actions = ({ deleteUser, ...props }) => {

    const style = {
        position: 'absolute',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        width: 400,
        bgcolor: 'background.paper',
        boxShadow: 24,
        p: 4,
    };

    const [modalOpen, setModalOpen] = React.useState(false)

    return <Box>
        <Link to={`/updateUser/${props.row._id}`}><IconButton><EditTwoToneIcon fontSize='small' /></IconButton></Link>
        <IconButton onClick={() => setModalOpen(true)}><DeleteOutlineTwoToneIcon fontSize='small' /></IconButton>
        <Modal
            open={modalOpen}
            onClose={() => setModalOpen(false)}
            aria-labelledby="modal-modal-title"
            aria-describedby="modal-modal-description"
        >
            <Box sx={style}>
                <Typography id="modal-modal-title" variant="h6" component="h2">
                    Confirm Deleting
                </Typography>
                <Typography id="modal-modal-description" sx={{ mt: 2 }} marginBottom='2rem'>
                    Are you sure you want to delete user "{props.row.firstName} {props.row.lastName}"?
                </Typography>
                <Box display='flex' flexDirection='row' justifyContent='space-between'>
                    <Button variant="contained" color='error' autoCapitalize={false} onClick={() => {
                        deleteUser(props.row._id)
                        setModalOpen(false)
                    }}>Delete</Button>
                    <Button variant="outlined" color='primary' onClick={() => setModalOpen(false)}>Cancel</Button>
                </Box>
            </Box>
        </Modal></Box>
}

export default Actions